// removed by extract-text-webpack-plugin
module.exports = {"row":"src-components-Row----Row-module---row---2m96w","reversed":"src-components-Row----Row-module---reversed---2xMJq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Row/Row.module.scss
// module id = 271
// module chunks = 221374088121123